module.exports = __webpack_public_path__ + "static/media/drawer-close-icon-grey-40x40.8c171cea.svg";